import { Box, Slide } from "@mui/material";
import { PlanPage } from "../../plan/PlanPage";
import { usePlanId, useSearchId } from "hooks/search";
import { PlanIdBoundary } from "../../common/boundary/PlanId";
import { Navigate } from "react-router";
import { useTenant } from "hooks/settings";
import { usePeriodIndex } from "hooks/periodIndex";

interface Props {
  width: string;
}

export const PlanPanel = ({ width }: Props) => {
  const planId = usePlanId();
  const tenant = useTenant();
  const searchId = useSearchId();
  const period = usePeriodIndex();
  return (
    <Slide
      in={planId === null ? false : true}
      direction="left"
      mountOnEnter
      unmountOnExit
    >
      <Box
        sx={{
          height: "100%",
          width,
          borderLeft: 1,
          position: "absolute",
          top: 0,
          right: 0,
          backgroundColor: "#ffffff",
          zIndex: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        {planId ? (
          <PlanIdBoundary
            fallback={
              <Navigate
                to={
                  searchId !== null
                    ? `/${tenant}/search?search=${searchId}&period=${period}`
                    : `/${tenant}/optimiser`
                }
              />
            }
          >
            <PlanPage />
          </PlanIdBoundary>
        ) : null}
      </Box>
    </Slide>
  );
};
